<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner
        class="m-2"
        variant="primary"
        role="status"
      ></b-spinner>
    </div>
    <div v-if="!mensagem">
      <div class="row"  v-if="!loading">
        <div class="col-md-4">
          <b-card>
            <b-card-title>
              Rateio Anual do Cooperado
            </b-card-title>
            <span></span>
            <apexchart
              class="apex-charts"
              height="350"
              type="bar"
              dir="ltr"
              :series="graficoDeSobrasAnuais.data.seriesRateioCooperado"
              :options="graficoDeSobrasAnuais.data.chartOptionsRateioCooperado"
            ></apexchart>
          </b-card>
        </div>
        <div class="col-md-4">
          <b-card>
            <b-card-title>
              Remuneração Anual do Cooperado
            </b-card-title>
            <apexchart
              class="apex-charts"
              height="350"
              type="bar"
              dir="ltr"
              :series="graficoDeSobrasAnuais.data.seriesRemuneracao"
              :options="graficoDeSobrasAnuais.data.chartOptionsRemuneracao"
            ></apexchart>
          </b-card>
        </div>
        <div class="col-md-4">
          <b-card>
            <b-card-title>
              Sobra Global Disponível pela Cooperativa
            </b-card-title>
            <span></span>
            <apexchart
              class="apex-charts"
              height="350"
              type="bar"
              dir="ltr"
              :series="graficoDeSobrasAnuais.data.seriesRateioGlobal"
              :options="graficoDeSobrasAnuais.data.chartOptionsRateioGlobal"
            ></apexchart>
          </b-card>
        </div>
        <span class="text-center my-2 fst-italic">OBS: Clique nos gráficos acima para carregar as informações abaixo <i class="mdi mdi-cursor-default-click"></i> </span>
      </div>
      <div class="d-flex justify-content-center" v-if="loadingTabelas">
        <b-spinner
          class="m-2"
          variant="primary"
          role="status"
        ></b-spinner>
      </div> 
      <div class="row" v-if="!loading && !loadingTabelas">
        <div class="col-md-6" >
          <b-card class="heightCardHeader">
            <b-card-title class="text-center">
              FÓRMULA DE CÁLCULO
            </b-card-title>
            <h4 class="text-center my-3">ANO {{this.dados.anos[this.index]}}</h4>
              <div class="row">
                <div class="flex-responsive justify-content-evenly align-items-center mt-4">
                  <div class="col-auto d-flex flex-column text-center">
                    <span>Remuneração Anual do Cooperado</span>
                    <span class="fw-bold font-size-18">{{$tools.converteReal(this.dados.vl_remunera[this.index])}}</span>
                    <hr class="my-1 m-auto" style="width: 100%; color: #000; opacity: 1 !important;"/>
                    <span class="fw-bold font-size-15">{{$tools.converteReal(this.dados.vl_total_remunera[this.index])}}</span>
                    <span>Total da Remuneração dos Cooperados</span>
                  </div>

                  <div class="col-auto">
                    <i class="mdi mdi-close-thick"></i>
                  </div>

                  <div class="col-auto d-flex flex-column text-center">
                    <span>Valor das Sobras para Rateio</span>
                    <span class="fw-bold font-size-18">{{$tools.converteReal(this.dados.vl_rateio_global[this.index])}}</span>
                  </div>

                  <div class="col-auto">
                    <i class="mdi mdi-equal"></i>
                  </div>

                  <div class="col-auto d-flex flex-column text-center">
                    <span>Valor Rateio do Cooperado</span>
                    <span class="fw-bold font-size-18">{{$tools.converteReal(this.dados.vl_rateio_cooperado[this.index])}}</span>
                  </div>
                </div>
              </div>

              <div class="row mt-5">
                <div class="mt-5 d-flex flex-column fst-italic ">
                  <span class="fw-bold">OBSERVAÇÕES:</span>
                  <span>1) Rateio aos cooperados conforme Art. 87 do Estatuto Social, salvo quando a Assembleia Geral deliberar de outra forma;</span>
                  <span>2) Crédito poderá ser compensado com débitos de conta corrente.</span>
                </div>
              </div>
          </b-card>
        </div>
        <div class="col-md-6">
          <b-card class="heightCardHeader">
            <b-card-title class="text-center">
              COMPOSIÇÃO DO CÁLCULO
            </b-card-title>
            <h4 class="text-center my-3">ANO {{this.dados.anos[this.index]}}</h4>
            <div class="col-md-12">
              <b-table
              class="datatables"
              responsive="sm"
              :fields="camposComposicao"
              :items="tabelaComposicao"
              :per-page="perPage" 
              :current-page="currentPage"
              striped
              foot-clone
            >
              <template #foot()="">
                <h6></h6>
              </template>
              <template #foot(DS_ITEM)="">
                <div class="text-end">
                  <span>Total: </span> 
                </div>
              </template>
              <template #foot(VL_LCTO)="">
                {{$tools.converteReal(totalTabela)}}
              </template>
            </b-table>
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
    <div v-if="mensagem">
      <div class="col-md-4">
        <b-card>
          <b-card-title>
            Não existem dados para serem mostrados.
          </b-card-title>
        </b-card>
      </div>
    </div>
  </div>
</template>


<script>
  import PageHeader from "@/components/page-header";
  import {
  graficoSobraAnual,
} from "./data-apex";

  export default {
    components: {
      PageHeader,
    },
    data() {
      return {
        title: "Demonstrativo de Sobras",
        items: [
          {
            text: "Demonstrativo de Sobras",
          },
        ],
        graficoDeSobrasAnuais: {},
        camposComposicao:[
          {
            key: "DT_REFERENCIA",
            label: "Mês Referência",
            class: "alinharCelula",
            formatter: (value) => {
              return this.$tools.converteData(value)
            },
          },
          {
            key: "DS_ITEM",
            label: "Item",
          },
          {
            key: "VL_LCTO",
            label: "Valor",
            class: "alinharCelulaDireita",
            formatter: (value) => {
              return this.$tools.converteReal(value)
            },
          },
        ],
        tabelaComposicao:[],
        dados:{
          vl_remunera: [],
          vl_rateio_cooperado: [],
          vl_total_remunera: [],
          vl_rateio_global: [],
          anos: [],
        },
        loading: false,
        totalTabela: 0,
        loadingTabelas: false,
        index: 0,
        perPage: 5,
        currentPage:1,
        rows:0,
        mensagem:false,
      };
    },

    created() {
      this.loading = true
      this.montaGrafico();
      this.$tools.fecharMenu();
    },

    methods:{
      montaGrafico(){
        this.$http.get("api/contaCorrente/creditos/grafico/S")
          .then((response) => {
            let aux = response.data;
            if(response.data.length == 0){
              this.loading = false
              this.mensagem = true;
              return
            }
            aux.forEach(el => {
              this.dados.vl_remunera.push(el.VL_REMUNERA)
              this.dados.vl_rateio_cooperado.push(el.VL_RATEIO_COOPERADO)
              this.dados.vl_total_remunera.push(el.VL_TOTAL_REMUNERA)
              this.dados.vl_rateio_global.push(el.VL_RATEIO_GLOBAL)
              this.dados.anos.push(el.NR_ANO)
            });
            this.mensagem = false;
            this.totalTabela = 0;
            this.graficoDeSobrasAnuais = graficoSobraAnual(this, this.dados);
            this.passaDados(this.dados.anos.length - 1);
            this.loading = false
          });
      },

      passaDados(index){
  this.totalTabela = 0;
  this.loadingTabelas = true
  this.index = index
  if(!this.dados.anos[this.index]){
    return;
  }
  this.$http.get("api/contaCorrente/creditos/"+this.dados.anos[this.index]+"/S")
    .then((response) => {
      this.tabelaComposicao = response.data
      this.rows = response.data.length 
      this.tabelaComposicao.forEach(el=>{
        this.totalTabela += parseFloat(el.VL_LCTO)
      })
      this.loadingTabelas = false
    });
},
    }

  };
</script>